var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtc-choose-calendar-wrap" },
    [
      _c("calendar", {
        ref: "calendar",
        attrs: {
          calendarType: _vm.calendarType,
          currentMonth: _vm.currentMonth,
          earliestMonth: _vm.earliestMonth,
          model: _vm.model,
          maxChoose: _vm.maxChoose,
          dateList: _vm.dateList,
          KDApi: _vm.KDApi
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }